<template>
<vs-sidebar position-right parent="body" color="primary" class="edit-sidebar sidebarx sidebarpage" spacer v-model="sidebarActive">
  <div @click.stop="">
      <div class="mt-2 flex items-center justify-between px-6">
    <h3 class="font-bold">{{title | truncate_dots(25)}}</h3>
    <!-- <InfoPopup/> -->
    <feather-icon icon="XIcon" @click.stop="sidebarActive=false" class="cursor-pointer text-dark p-1" :class="actionElementCss" ></feather-icon>
  </div>
  <vs-divider class="mb-0"></vs-divider>
    <VuePerfectScrollbar :class="scrollAreaSidebarClass" :settings="settings">
      <div class="pb-32">
        <slot></slot>
      </div>

    </VuePerfectScrollbar>
  </div>

  <template v-slot:footer>
    <div class="my-2 flex justify-center">
      <slot name="sidebar-footer"></slot>
    </div>
  </template>
</vs-sidebar>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    initValue: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true,
    },
    saveButton: {
      type: Boolean,
      required: false,
    }

  },
  data () {
    return {
      sidebarActive:       false,
      escListener:         null,
      enterListener:       null,
      settings: {
        maxScrollbarLength: 30,
        wheelSpeed: 1,
        suppressScrollX: true
      },
    }
  },
  computed: {
    scrollAreaSidebarClass () {
      return 'scroll-area-sidebar'

      // return this.saveButton ? 'scroll-area-sidebar-footer' : 'scroll-area-sidebar'
    }
  },
  watch: {
    initValue: {
      immediate: true,
      handler (initValue) {
        console.log('handler initValue', initValue)
        this.sidebarActive = initValue
      }
    },
    sidebarActive: {
      immediate: true,
      handler (sidebarActive) {
        if (!sidebarActive) {
          this.$emit('close')
        }
      }
    }
  },
  created () {
    this.escListener = document.addEventListener('keyup', (evt) => {
      if (evt.keyCode === 27) {
        this.sidebarActive = false
      }
    })

    this.enterListener = document.addEventListener('keyup', (evt) => {
      if (evt.keyCode === 13) {
        if (this.sidebarActive) {
          this.$emit('enterClick')

        }
      }
    })
  },
  destroy () {
    document.removeEventListener(this.escListener)
    document.removeEventListener(this.enterListener)
  }
}
</script>

<style lang="scss">
.scroll-area-sidebar {
  height: calc(var(--vh, 1vh) * 100 - 16px - 55px);
}

.scroll-area-sidebar-footer {
  height: calc(var(--vh, 1vh) * 100 - 16px - 55px  - 45px);
}

.theme-dark {
  .scroll-area-sidebar {
    background-color: #262c49 !important;
  }
}

</style>
